export { default as VideoControlBar } from './component';
